import * as React from 'react';

import EmptyStateDetails from './EmptyStateDetails';

export const emptyStateDetails = () => <EmptyStateDetails />;

export default {
    title: 'Illustration/EmptyStateDetails',
    component: EmptyStateDetails,
    parameters: {
        notes: "`import EmptyStateDetails from 'box-ui-elements/es/illustration/EmptyStateDetails';`",
    },
};
